export class ReadMore extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.els.readMore?.exists) {
      this.listeners.add(
        this.els.readMore.element,
        'click',
        this.onReadMore.bind(this),
      )
    }

    if (this.els.viewLess?.exists) {
      this.listeners.add(
        this.els.viewLess.element,
        'click',
        this.onViewLess.bind(this),
      )
    }
  }

  onReadMore () {
    this.els.long.element.classList.toggle('util-ScreenReaderOnly', false)
    this.els.short.element.classList.toggle('util-ScreenReaderOnly', true)
    this.setAttribute('aria-expanded', true)
  }

  onViewLess () {
    this.els.long.element.classList.toggle('util-ScreenReaderOnly', true)
    this.els.short.element.classList.toggle('util-ScreenReaderOnly', false)
    this.setAttribute('aria-expanded', false)
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore)
}
